var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"subTable",staticClass:"text-area"},_vm._l((_vm.theText),function(t,i){return _c('p',{key:i,domProps:{"innerHTML":_vm._s(t)}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }